<template>
  <div class="boxt">
    <div class="side">
      <div class="deng" @click="logint" v-show="iscond">
        <img class="simg sa" src="../assets/images/用户名.png" alt />
        <img class="simg sb" src="../assets/images/用户名(4).png" alt />
        <span>登录</span>
      </div>
      <div class="deng" @click="Logout" v-show="!iscond">
        <img class="simg sa" src="../assets/images/用户名.png" alt />
        <img class="simg sb" src="../assets/images/用户名(4).png" alt />
        <span>退出</span>
      </div>
      <div class="ceng" @click="Register">
        <img class="simg sa" src="../assets/images/用户名(1).png" alt />
        <img class="simg sb" src="../assets/images/用户名(5).png" alt />
        <span>注册</span>
      </div>
      <div class="customer" @click="openAi()">
        <img class="simg sa" src="../assets/images/科创AI(1).png" alt />
        <img class="simg sb" src="../assets/images/科创AI(2).png" alt />
        <span>科创AI</span>
      </div>
      <div class="public">
        <img class="simg sa" style="width: 1.896875rem" src="../assets/images/用户名(2).png" alt />
        <img class="simg sb" style="width: 1.896875rem" src="../assets/images/用户名(6).png" alt />
        <span>公众号</span>
        <div class="puimg">
          <div></div>
          <img src="../assets/images/GzH.jpg" alt />
        </div>
      </div>
      <div class="appd">
        <img class="simg sa" src="../assets/images/用户名(3).png" alt />
        <img class="simg sb" src="../assets/images/用户名(7).png" alt />
        <span>手机端</span>
        <div id="shouj"></div>
        <div class="sanjao"></div>
      </div>
      <div class="chie">
        <img
          class="simg sa"
          style="width: 1.236875rem; height: 1.608125rem"
          src="../assets/images/电话.png"
          alt
        />
        <img
          class="simg sb"
          style="width: 1.236875rem; height: 1.608125rem"
          src="../assets/images/电话(1).png"
          alt
        />
        <span>技术支持</span>
        <div class="chetext">13937151235</div>
      </div>
      <div class="customer" @click="open53()">
        <img class="simg sa" src="../assets/images/技术支持 (1).png" alt />
        <img class="simg sb" src="../assets/images/技术支持 (2).png" alt />
        <span>在线客服</span>
      </div>
    </div>
    <div class="fan" v-show="goTopShow" @click="goTop">
      <img class="simg" src="../assets/images/返回顶部(1).png" alt />
      <div>返回顶部</div>
    </div>
  </div>
</template>
<script>
;(function () {
  var _53code = document.createElement('script')
  _53code.src =
    'https://tb.53kf.com/code/code/ebf6b686dc412fc05a0f88af69b1b33b0/2'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(_53code, s)
})()
import QRCode from 'qrcodejs2'
import { imgcommonUrl } from '../api/url.js'
export default {
  data() {
    return {
      iscond: true,
      scrollTop: '',
      goTopShow: false,
    }
  },
  watch: {
    scrollTop(val) {
      if (this.scrollTop > 500) {
        this.goTopShow = true
      } else {
        this.goTopShow = false
      }
    },
  },
  created() {
    this.iscond = localStorage.getItem('RealID') ? true : false
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.getCoed()
  },
  updated() {},
  methods: {
    // 53客服
    open53() {
      var _53 = $53.createApi() /*开发者文档1.1 创建SDK资源对象*/
      _53.push('cmd', 'kfclient') /*开发者文档1.2 打开pc访客端*/
      _53.push('type', 'new')
      _53.query()
    },
    openAi(){
     // window.open("https://www.hnkczx.cn:8094/pophome", '_blank'); // '_blank' 表示在新标签页打开
      this.$emit('OpenAiDialog')
    },
    //登录
    isLogin() {
      this.iscond = !this.iscond
    },

    logint() {
      if (window.localStorage.getItem('RealName') == '') {
        this.$emit('OpenLogin')
      } else {
        this.Logout()
      }
    },
    //退出
    Logout() {
      this.$emit('Logout')
    },
    //注册
    Register() {
      this.$emit('toRegister')
    },
    //
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.scrollTop > 500) {
        this.goTopShow = true
      }
    },
    goTop() {
      let timer = null,
        _that = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 50
          document.body.scrollTop = document.documentElement.scrollTop =
            _that.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          _that.goTopShow = false
        }
      })
    },
    //二维码
    getCoed() {
      document.getElementById('shouj').innerHTML = ''
      let qrcode = new QRCode('shouj', {
        width: 70, // 宽
        height: 70, // 高
        text: imgcommonUrl + '/Mobile/index.html', // 二维码内容,也可以直接放接口获取的数据
        render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      })
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style scoped>
.boxt {
  width: 5rem;
  height: 37rem;
  cursor: pointer;
}
.side > div {
  z-index: 99;
  width: 5rem;
  height: 5rem;
  background: #fff;
  border-bottom: 0.0625rem solid #f5f5f5;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 400;
  color: #686f88;
  cursor: pointer;
  box-shadow: 0 0.1875rem 1.25rem rgba(0, 0, 0, 8%);
}
.simg {
  margin: 0rem auto 0.25rem;
  width: 1.625rem;
  height: 1.625rem;
  padding-top: 1rem;
}
.side div span {
  display: block;
}
.fan {
  margin-top: 1.5rem;
  width: 5rem;
  height: 5rem;
  background: #2a3457;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 400;
  color: #fff;
}
.fan img {
  width: auto;
  height: auto;
  margin: 1rem auto 0.25rem;
  padding: 0;
}
.public {
  position: relative;
}
.puimg {
  width: 6.5rem;
  height: 6.5rem;
  position: absolute;
  top: 0;
  right: 9rem;
  display: none;
}
.puimg div {
  width: 0;
  height: 0;
  border: 1rem solid transparent;
  border-left: 1rem solid #fff;
  position: absolute;
  top: 1.5rem;
  right: -3.4rem;
}
.puimg > img {
  width: 100%;
  height: 100%;
}

.chie {
  position: relative;
}
.chetext {
  font-size: 1.8rem;
  font-weight: 600;
  position: absolute;
  top: 1rem;
  right: 9rem;
  color: #333;
  width: 14rem;
  height: 4rem;
  background: #fff;
  line-height: 4rem;
  text-align: center;
  border-radius: 1rem;
  display: none;
}
.chetext::after {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border: 1rem solid transparent;
  border-left: 1rem solid #fff;
  position: absolute;
  top: 0.5rem;
  right: -3.4rem;
}
.chie:hover .chetext {
  display: block;
}
.side div:hover {
  background: #f58a3a;
  color: #fff;
}
.sb {
  display: none;
}
.customer:hover .sa {
  display: none;
}
.customer:hover .sb {
  display: block;
}
.chie:hover .sa {
  display: none;
}
.chie:hover .sb {
  display: block;
}
.appd:hover .sa {
  display: none;
}
.appd:hover .sb {
  display: block;
}
.public:hover .sa {
  display: none;
}
.public:hover .sb {
  display: block;
}
.public:hover .puimg {
  display: block;
}
.ceng:hover .sa {
  display: none;
}
.ceng:hover .sb {
  display: block;
}
.deng {
  z-index: 9;
}
.deng:hover {
  background: #f58a3a;
  color: #fff;
}
.deng:hover .sa {
  display: none;
}
.deng:hover .sb {
  display: block;
}
.appd {
  position: relative;
}
#shouj {
  position: absolute;
  top: 0;
  left: -10rem;
  display: none;
}
.appd:hover #shouj {
  display: block;
}
.sanjao {
  width: 0;
  height: 0;
  border: 1rem solid transparent;
  border-left: 1rem solid #fff;
  position: absolute;
  top: 0.5rem;
  left: -2.5rem;
  display: none;
}
.appd:hover .sanjao {
  display: block;
}
</style>
